import { getMembersByEmployeeSSN } from "./get.member.membersByEmployeeSSN";
import { getDependentBySSNWithEmployee } from "./get.member.dependentBySNNWithEmployee";
import { editEmployeeInformationById } from "./employee/editEmployeeInformation";
import { editContactInformationById } from "./employee/editContactInformation";
import { editDependentProfileInformationById } from "./dependent/editDependentProfileInformation";
import { editDependentContactInformationById } from "./dependent/editDependentContactInformation";
import { getPaycheckByEmployeeSSN } from "./paycheck/get.paycheckByEmployeeSSN";
import { getEmployeeAndPaycheckByEmployeeSSN } from "./paycheck/get.member.paycheckByEmployeeSSN";
import { addEmployment } from "./paycheck/addEmployment";
import { getEmployeeAndAssignedLocations } from "./paycheck/get.member.assignLocationsByEmployeeSSN";
import { getEmployeeAndPaycheckWithAssignedLocations } from "./paycheck/get.member.paycheckAndassignLocationsByEmployeeSSN";
import { addPaycheck } from "./paycheck/addPaycheck";
import { termEmployment } from "./paycheck/termEmployment";
import { reinstateEmployment } from "./paycheck/reinstateEmployment";
import { rehireEmployment } from "./paycheck/rehireEmployment";
import { getMemberActivityLogBySSN } from "./get.memberActivityLogBySSN";
import { getExistsMemberEnrollemnt } from "./get.exists.memberenrollmentBySSN";

export const member = {
	getMembersByEmployeeSSN,
	getExistsMemberEnrollemnt,
	getDependentBySSNWithEmployee,
	editEmployeeInformationById,
	editContactInformationById,
	editDependentProfileInformationById,
	editDependentContactInformationById,
	getPaycheckByEmployeeSSN,
	getEmployeeAndPaycheckByEmployeeSSN,
	getEmployeeAndAssignedLocations,
	addEmployment,
	getEmployeeAndPaycheckWithAssignedLocations,
	addPaycheck,
	termEmployment,
	reinstateEmployment,
	rehireEmployment,
	getMemberActivityLogBySSN
};
